import { ReactNode } from 'react'

import Box from '@totallymoney/ui/components/Box'
import Card from '@totallymoney/ui/components/Card'
import Flex from '@totallymoney/ui/components/Flex'

import { borderStyle } from '@styles/borderStyle'

export const ItemBase = ({
    children,
    productCode,
}: {
    children: ReactNode
    productCode: string
}) => (
    <Card
        hasBorder
        hasShadow={false}
        borderRadius="borderRadius30"
        p={['space20', 'space30']}
        pt={['space20', 'space30']}
        overflow="hidden"
        position="relative"
        data-testid={`unscored-table-item-${productCode}`}
    >
        {children}
    </Card>
)

export const ItemWrapper = ({ children }: { children: ReactNode }) => (
    <Box display="grid" gridAutoColumns="1fr" mb="space30">
        {children}
    </Box>
)

export const ItemHeading = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn={['span 12', '1/7', '1/10']}
        pb={['space20', 'space20', 'space30']}
    >
        {children}
    </Box>
)

export const ItemImage = ({ children }: { children: ReactNode }) => (
    <Flex
        position="relative"
        gridColumn={['1/13', '1/7', '1/4']}
        gridRow={['2', 'unset']}
        justifyContent={['center', 'flex-start']}
        pr="space10"
    >
        {children}
    </Flex>
)

export const ItemContent = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn={['span 12', 'span 12', '4/10']}
        gridRow={['unset', '4', '2/4']}
        display={['block', 'flex']}
        justifyContent={['unset', 'center']}
        flexDirection="column"
        mt={['space20', 'space30', 0]}
        mb={['space20', 0]}
    >
        {children}
    </Box>
)

export const ItemButtons = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn={['span 12 / auto', '11/13']}
        gridRow={['unset', '2']}
        justifySelf={['unset', 'flex-end', 'center']}
        alignSelf={['unset', 'center']}
        width={['unset', '208px']}
    >
        {children}
    </Box>
)

export const ItemFooter = ({ children }: { children: ReactNode }) => (
    <Box
        backgroundColor="grey10"
        mx="-space30"
        mb="-space30"
        p="space30"
        pt="space15"
    >
        {children}
    </Box>
)
